export default __webpack_public_path__ + "static/media/Artist1.e043f77c.svg";